import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BusyIndicatorService } from 'src/services/busy-indicator.service';
import { AuthService, ITokenResponse } from 'src/services/auth.service';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, AfterViewInit {
  isBusy = false;
  opened = true;
  collapsed = false;
  currentUser$: Observable<ITokenResponse>;

  constructor(
    private busyIndicator: BusyIndicatorService
    , private authSvc: AuthService
    , private logger: NGXLogger) {
  }

  ngOnInit(): void {
    this.currentUser$ = this.authSvc.currentUser;
  }

  ngAfterViewInit(): void {
    this.busyIndicator.busy
      .subscribe(res => {
        this.logger.warn('layout isBusy', res);
        // Avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.isBusy = res;
        }, 0);
      })
  }

  toggleGnb() {
    if (this.opened) {
      // 메뉴가 닫히고, 잠시 후 닫힌 메뉴 노출
      this.opened = !this.opened;
      setTimeout(() => {
        this.collapsed = !this.opened;
      }, 100);
    } else {
      // 메뉴가 열리고, 닫힌 메뉴 닫기
      this.opened = !this.opened;
      this.collapsed = !this.opened;
    }
  }
}
